import { useEffect, useRef } from "react";

/**
 * Closes an open menu on a click outside `containerRef`, while `isOpen` is
 * true. `ResourceCard` and `AddNewMenu` share it.
 */
export default function useCloseOnOutsideClick<T extends HTMLElement>(
  containerRef: React.RefObject<T>,
  isOpen: boolean,
  onClose: () => void
): void {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        onCloseRef.current();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, containerRef]);
}
